import { formatearFechaConHora, formatearFechaSinHora } from "@shared/utils/date.utils";
import IEstado from "./estado.interface";
import { IPorcentajesDocumentos, ISancion } from "./expediente.interface";
import { Prestador } from "./prestador.model";
import IRegion from "./region.interface";
import IMotivo from "./motivo.interface";
import SiNo from "@shared/enums/si-no.enum";
import ILicencia from "./licencia.interface";
import ICompin from "./compin.interface";
import { Trabajador } from "./trabajador.model";
import { Persona } from "./persona.model";

export class Licencia implements ILicencia {
    id: number;
    num_licencia: string;
    numero: number;
    trabajador: Trabajador;
    estado: IEstado;
    estadoContraloria: IEstado;
    fecha_creacion: string;
    fecha_emision: string;
    fecha_recepcion: string;
    compin: ICompin;
    dias_otorgados: number;
    empleador: Persona;
    porcentajesDocumentos: IPorcentajesDocumentos
    no_cumplen: number;

    getFechaCreacion() {
        return formatearFechaConHora(this.fecha_creacion);
    }

    getFechaCreacionSinHora() {
        return formatearFechaSinHora(this.fecha_creacion);
    }

    getFechaEmision() {
        return formatearFechaConHora(this.fecha_emision);
    }

    getFechaEmisionSinHora() {
        return formatearFechaSinHora(this.fecha_emision);
    }

    getFechaRecepcion() {
        return formatearFechaConHora(this.fecha_recepcion);
    }

    getFechaRecepcionSinHora() {
        return formatearFechaSinHora(this.fecha_recepcion);
    }
}